export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    function isFormMakerBackgroundComponent(selected) {
        return typeof PMW.formmaker !== 'undefined' && selected.is(PMW.formmaker.components.structural.PMW_FORM_BACKGROUND) && selected.parent().is(PMW.formmaker.components.structural.PMW_SIGNUP_FORM);
    }

    styleManager.addType('pmw-font-selector', {
        create({props, change}) {
            props.component = props.component || editor.getSelected();
            let selected = props.component,
                styles = selected.getStyle() || {},
                currFont = styles['font-family'] || props.defaults.value,
                allComponentsWithFont = null;

            if (isFormMakerBackgroundComponent(selected)) {
                allComponentsWithFont = editor.runCommand(window.PMW.emails.commands.GET_ALL_COMPONENTS_WITH_FONT);

                currFont = areAllFontsSame(allComponentsWithFont);
            }

            const [labelContainer, selectorContainer] = getFontSelectorContainers(props, currFont);
            attachFontSelectorHandlers(props, labelContainer, selectorContainer, allComponentsWithFont, change);

            return labelContainer;
        },

        emit({props}, {labelContainer, itemEl, fontFamily, fontName, allComponentsWithFont}) {
            let selected = props.component || editor.getSelected();

            if (isFormMakerBackgroundComponent(selected) && allComponentsWithFont.length) {
                allComponentsWithFont.map(component => {
                    editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {
                        component: component,
                        property: props.property,
                        value: fontFamily,
                    });
                })
            }

            $(itemEl).addClass('-selected')
                .siblings('.js-fonts-list-item').removeClass('-selected');

            $(labelContainer).find('.js-font-label-btn-txt')
                .html(fontName).css('font-family', fontFamily);

            editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {
                component: props.component,
                property: props.property,
                value: fontFamily,
            });
        },
    });

    function getFontSelectorContainers(props, currFont) {
        const labelContainer = document.createElement('div'),
            selectorContainer = document.createElement('div');
        labelContainer.className = props.type;
        selectorContainer.className = props.type;

        let selectedFont = null;

        const infoContainer = `<div class="info-wrapper -warning">
                <div class="info-box">
                    <div class="body-xs info-message">
                        ${i18next.t('pmwjs_fonts_email_warning')}
                    </div>
                </div>
            </div>`,

            fontsList = `<ul class="fonts-list"> 
                ${props.list.map(font => {
                let selectedClass = '';
                if (font.value === currFont) {
                    selectedFont = font;
                    selectedClass = '-selected';
                }

                return `<li class="fonts-list-item js-fonts-list-item ${selectedClass}">
                            <span class="fonts-list-item-text body-s js-fonts-list-item-text"
                                data-font-family="${font.value}" data-font-name="${font.name}" 
                                style="font-family: ${font.value}">${font.name}</span>
                            <i class="icon icon-check body-l"></i>
                        </li>`;
            }).join('')}
            </ul>`,

            fontsListContainer = `<div class="fonts-list-container">
                <span class="fonts-list-title body-xs-bold">${i18next.t('pmwjs_fonts')}</span>
                ${fontsList}
            </div>`;

        selectorContainer.innerHTML = `<div class="selector-container">
                ${infoContainer}
                ${fontsListContainer}
            </div>`;

        labelContainer.innerHTML = `<div class="label-container">
                <span class="style-manager-label">${props.label}</span>
                <button class="font-label-btn js-font-label-btn">
                    <span class="font-label-btn-txt body-s js-font-label-btn-txt">${selectedFont ? selectedFont.name : 'Mixed'}</span>
                </button>
            </div>`;

        return [labelContainer, selectorContainer];
    }

    function attachFontSelectorHandlers(props, labelContainer, selectorContainer, allComponentsWithFont, change) {
        PMW.onClick($(labelContainer), '.js-font-label-btn', function () {
            editor.runCommand(window.PMW.emails.commands.OPEN_SIDE_PANEL, {
                title: i18next.t('pmwjs_font'),
                content: selectorContainer,
            });
        });

        selectorContainer.querySelectorAll('.js-fonts-list-item').forEach(itemEl => {
            const textItem = itemEl.querySelector('.js-fonts-list-item-text'),
                fontFamily = textItem.getAttribute('data-font-family'),
                fontName = textItem.getAttribute('data-font-name');

            itemEl.addEventListener('click', function (fontFamily, fontName, allComponentsWithFont) {
                change({labelContainer, itemEl, fontFamily, fontName, allComponentsWithFont});
            }.bind(null, fontFamily, fontName, allComponentsWithFont));
        });
    }

    /**
     * If all of the components have the same font, returns the font. Else, returns null.
     *
     * @param {grapesjs.Component[]} components
     * @returns {string|null}
     */
    function areAllFontsSame(components) {
        let font = null;

        for (let i = 0; i < components.length; i++) {
            let componentFont = components[i].getStyle()['font-family'];
            if (!font) {
                font = componentFont;
                continue;
            }

            if (componentFont !== font) {
                return null;
            }
        }

        return font;
    }
}